<template>
  <layout-main-inner
    title="订单详情"
    class="order-detail">
    <el-form
      ref="ruleForm"
      class="order-create-wrap"
      :model="outstock"
      label-position="top">
      <div>
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="订单"
            name="1"></el-tab-pane>
          <el-tab-pane
            label="发货单"
            name="2"></el-tab-pane>
          <el-tab-pane
            label="退货单"
            name="3"></el-tab-pane>
          <el-tab-pane
            label="售后工单"
            name="4"></el-tab-pane>
          <!-- <el-tab-pane
            label="发货单"
            name="5"></el-tab-pane> -->
        </el-tabs>
      </div>
      <template v-if="activeName === '1'">
        <layout-card-wrap
          v-loading="loading"
          hasHeaderSlot>
          <template slot="title">
            <div>
              <span>基本信息</span>
              <span style="margin-left: 16px;color:#000;font-size: 14px">审单人：{{ outstock.auditStaffName || '-' }}</span>
              <span style="margin-left: 16px;color:#000;font-size: 14px">销售人：{{ outstock.saleStaffName || '-' }}</span>
              <span style="margin-left: 16px;color:#000;font-size: 14px">销售部门：{{ outstock.saleDepartmentName || '-' }}</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="订单号:"
                prop="code">{{ outstock.code }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="订单来源:"
                prop="code"> {{ outstock.source | sourceName() }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="订单状态:"
                prop="status">  {{ outstock.status | orderStatusName() }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="发货状态:"
                prop="outStatus"> {{ outstock.outStatus | orderOutStatusName() }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="发货方式:"
              >
                <span v-if="outstock.outType === 0">待定</span>
                <span v-if="outstock.outType === 1 && outstock.orderFlag === 1">正常发货</span>
                <span v-if="outstock.outType === 1 && outstock.orderFlag === 2">改单发货</span>
                <span v-if="outstock.outType === 2 && outstock.orderFlag === 3">空包发货</span>
                <span v-if="outstock.outType === 1 && outstock.orderFlag === 3">刷单发货</span>
                <!-- {{ outstock.outType | orderOutTypeName() }}<span v-if="outstock.orderFlag && outstock.orderFlag!=='0'">({{ outstock.orderFlag | orderTagName() }})</span> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="物流方式:"
                prop="transType">
                {{ outstock.transType | transTypeName() }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="发货仓库:"
                prop="warehouseNo">{{ outstock.warehouseNo | warehouseName() }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="物流模板:"
                prop="logisticsCode">
                {{ outstock.logisticsCode |expressName() }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="交易时间:"
                prop="tradeTime">{{ outstock.tradeTime | dateformat() }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发件人信息:">
                <div slot="label">
                  <span>发件人信息:</span>
                  <el-tooltip
                    effect="dark"
                    content="根据物流模板信息获取">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
                <div>
                  <span>{{ outstock.senderName }}</span>
                  <span v-if="outstock.senderMobile">
                    <i
                      style="margin-left: 5px"
                      class="el-icon-mobile-phone"></i>{{ outstock.senderMobile }}
                  </span>
                </div>
                <div>{{ outstock.senderProvince }}{{ outstock.senderCity }}{{ outstock.senderDistrict }}-{{ outstock.senderAddress }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收件人信息:">
                <div>
                  <span>{{ outstock.receiverName }}</span>
                  <span v-if="outstock.receiverMobile">
                    <i
                      style="margin-left: 5px"
                      class="el-icon-mobile-phone"></i>{{ outstock.receiverMobile }}
                  </span>
                  <span v-if="outstock.receiverTel">
                    <i
                      style="margin-left: 5px"
                      class="el-icon-phone-outline"></i>{{ outstock.receiverTel }}
                  </span>
                </div>
                <div>{{ outstock.receiverProvince }}{{ outstock.receiverCity }}{{ outstock.receiverDistrict }}-{{ outstock.receiverAddress }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="备注:"
                prop="remark">
                <span>{{ outstock.remark || '-' }}</span>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editremark(outstock)">修改</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider>其他信息</el-divider>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="收款条件:"
                prop="recConditionName">{{ outstock.recConditionName }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="折扣率:"
                prop="rtg">{{ outstock.rtg }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="客户分组:"
                prop="custGroupName">{{ outstock.custGroupName }}</el-form-item>
            </el-col>
          </el-row>
        </layout-card-wrap>
        <layout-card-wrap
          v-loading="loading"
          style="margin-top:8px"
          hasHeaderSlot>
          <template slot="title">
            <span>订单明细</span>
          </template>
          <el-form-item
            v-loading="outstock.outType === 2"
            class="loading-wrap"
            element-loading-text="空包"
            element-loading-spinner="el"
            element-loading-background="rgba(255, 255, 255, 0.7)"
            label-width="0"
            prop="detailList">
            <el-table
              v-loading="loading"
              show-summary
              :summary-method="getSummaries"
              :data="outstock.detailList"
              border>
              <el-table-column
                :resizable="false"
                label="商品名称"
                width="260"
                prop="skuName">
                <template slot-scope="{row}">
                  {{ row.skuName || row.productName }}
                  <el-tag v-if="row.isFree === 1">赠</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                :resizable="false"
                label="商品编码"
                width="90"
                prop="skuCode"></el-table-column>
              <el-table-column
                label="下单数量"
                :resizable="false"
                prop="num">
                <template slot-scope="{row}">{{ row.num }} {{ row.measureUnit | measureUnitName() }}</template>
              </el-table-column>
              <el-table-column
                label="已发货数量"
                :resizable="false"
                prop="realOutNum">
                <template slot-scope="{row}">{{ row.realOutNum }} {{ row.measureUnit | measureUnitName() }}</template>
              </el-table-column>
              <el-table-column
                label="零售价"
                :resizable="false"
                prop="retailPrice">
                <template slot-scope="{row}">¥{{ row.retailPrice }}</template>
              </el-table-column>
              <el-table-column
                label="单件优惠金额"
                :resizable="false"
                prop="discountAmount">
                <template slot-scope="{row}">¥{{ row.discountAmount }}</template>
              </el-table-column>
              <el-table-column
                label="成交价"
                :resizable="false"
                prop="actualPrice">
                <template slot-scope="{row}">¥{{ row.actualPrice }}</template>
              </el-table-column>
              <el-table-column
                label="操作"
                :resizable="false"
                fixed="right"
                width="120">
                <template slot-scope="{row}">
                  <el-button
                    type="primary"
                    @click="viewtags(row)">标签码</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        <!-- <el-row>
          <el-col :span="8">
            <el-form-item
              label="商品总金额:"
              prop="itemAmount">
              {{ outstock.itemAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="订单金额:"
              prop="totalAmount">
              {{ outstock.totalAmount }}
            </el-form-item>
          </el-col>
        </el-row>-->
        </layout-card-wrap>
      </template>
      <template v-if="activeName === '2'">
        <template v-if="outList.length > 0">
          <layout-card-wrap
            v-for="item in outList"
            :key="item.id"
            v-loading="loading"
            style="margin-top:8px"
            hasHeaderSlot>
            <template slot="title">
              <div>
                <span>发货单号：{{ item.code }}</span>
                <span style="margin-left: 16px;color:#000;font-size: 14px">创建人：{{ item.createName }}</span>
                <span style="margin-left: 16px;color:#000;font-size: 14px">创建时间：{{ item.createTime | dateformat() }}</span>
                <span style="margin-left: 16px;color:#000;font-size: 14px">执行人：{{ item.storekeeperStaffName || '-' }}</span>
              </div>
            </template>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item
                  label="仓库:">{{ item.warehouseNo | warehouseName() }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="出库类型:">
                  {{ item.type | outTypeName() }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="出库状态:"><span :style="{color:item.status === 9 ? 'red' : null}">{{ item.status | outStatusName() }}</span></el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="面单打印状态:">{{ item.printStatus | printStatusName() }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="发货类型:">{{ item.transType | transTypeName() }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="创建时间:"> {{ item.createTime | dateformat() }}</el-form-item>
              </el-col>
              <template v-if="item.transType !== 3">
                <el-col
                  :span="8">
                  <el-form-item
                    label="物流模板:"
                    prop="expressCode">
                    {{ item.expressCode | expressName() }}
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8">
                  <el-form-item
                    label="物流单号:"
                    prop="expressCode">
                    {{ item.sendOrderList.logisticsCode || '-' }}
                    <el-button
                      v-if="item.sendOrderList.logisticsCode"
                      type="text"
                      size="mini"
                      icon="el-icon-view"
                      @click="getdeliverytrace(item.sendOrderList)">查看</el-button>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="8">
                  <el-form-item label="发件人信息:">
                    <div slot="label">
                      <span>发件人信息:</span>
                      <el-tooltip
                        effect="dark"
                        content="根据物流模板信息获取">
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </div>
                    <div>
                      <span>{{ item.sendOrderList.senderName }}</span>
                      <span v-if="item.sendOrderList.senderMobile">
                        <i
                          style="margin-left: 5px"
                          class="el-icon-mobile-phone"></i>{{ item.sendOrderList.senderMobile }}
                      </span>
                    </div>
                    <div>{{ item.sendOrderList.senderProvince }}{{ item.sendOrderList.senderCity }}{{ item.sendOrderList.senderDistrict }}-{{ item.sendOrderList.senderAddress }}</div>
                  </el-form-item>
                </el-col>
              </template>
              <el-col :span="12">
                <el-form-item label="收件人信息:">
                  <div>
                    <span>{{ item.sendOrderList.receiverName }}</span>
                    <span v-if="item.sendOrderList.receiverMobile">
                      <i
                        style="margin-left: 5px"
                        class="el-icon-mobile-phone"></i>{{ item.sendOrderList.receiverMobile }}
                    </span>
                    <span v-if="item.sendOrderList.receiverTel">
                      <i
                        style="margin-left: 5px"
                        class="el-icon-phone-outline"></i>{{ item.receiverTel }}
                    </span>
                  </div>
                  <div>{{ item.sendOrderList.receiverProvince }}{{ item.sendOrderList.receiverCity }}{{ item.sendOrderList.receiverDistrict }}-{{ item.sendOrderList.receiverAddress }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              v-loading="outstock.outType === 2"
              label="明细:"
              class="loading-wrap"
              element-loading-text="空包"
              element-loading-spinner="el"
              element-loading-background="rgba(255, 255, 255, 0.7)">
              <el-table
                v-loading="loading"
                :data="item.detailList"
                border>
                <el-table-column
                  :resizable="false"
                  label="商品名称"
                  prop="skuName">
                  <template slot-scope="{row}">
                    {{ row.skuName || row.productName }}
                    <el-tag v-if="row.isFree === 1">赠</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  label="商品编码"
                  width="100"
                  prop="skuCode"></el-table-column>
                <el-table-column
                  label="出库数量"
                  :resizable="false"
                  prop="num">
                  <template slot-scope="{row}">{{ row.num }} {{ row.measureUnit | measureUnitName() }}</template>
                </el-table-column>
                <el-table-column
                  label="实际出库数量"
                  :resizable="false"
                  prop="realNum">
                  <template slot-scope="{row}">{{ row.realNum }} {{ row.measureUnit | measureUnitName() }}</template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </layout-card-wrap>
        </template>
        <sh-empty v-else />
      </template>
      <template v-if="activeName === '3'">
        <template v-if="returnList.length > 0">
          <layout-card-wrap
            v-for="item in returnList"
            :key="item.goodsReturnId"
            v-loading="loading"
            style="margin-top:8px"
            hasHeaderSlot>
            <template slot="title">
              <span>退货单号：{{ item.goodsReturnCode }}</span>
            </template>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item
                  label="退货总数:">  {{ item.returnGoodsCount }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="下单人信息:">
                  {{ item.deliveryName }}-{{ item.deliveryPhone }}-{{ item.detailedAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="退货时间:"> {{ item.goodsReturnTime | dateformat() }}</el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="明细:">
              <el-table
                v-loading="loading"
                :data="item.goodsReturnItems"
                border>
                <el-table-column
                  label="商品名称"
                  :resizable="false"
                  prop="productName">
                  <template slot-scope="{row}">
                    {{ row.skuName || row.productName }}
                    <el-tag v-if="row.isFree === 1">赠</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  label="退货数量"
                  :resizable="false"
                  prop="returnGoodsCount">
                  <template slot-scope="scope">{{ scope.row.returnGoodsCount }} {{ scope.row.measureUnit | measureUnitName() }}</template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </layout-card-wrap>
        </template>
        <sh-empty v-else />
      </template>
      <template v-if="activeName === '4'">
        <template v-if="saleList.length > 0">
          <layout-card-wrap
            v-loading="loading"
            hasHeaderSlot>
            <template slot="title">售后明细</template>
            <el-timeline>
              <el-timeline-item
                v-for="item in saleList"
                :key="item.postSaleOrderId"
                :timestamp="item.createdTime | dateformat()"
                placement="top">
                <el-card>
                  <el-form
                    label-width="70px"
                    label-position="left">
                    <el-form-item label="售后单号：">
                      {{ item.postSaleOrderNumber }}
                    </el-form-item>
                    <el-form-item label="备注：">
                      {{ item.reason }}
                    </el-form-item>
                    <el-form-item label="售后类型：">
                      <span v-if=" item.type === 2">退货</span>
                      <span v-if=" item.type === 3">换货</span>
                    </el-form-item>
                    <el-form-item label="状态：">
                      {{ item.status | aftersaleStatus() }}
                    </el-form-item>
                    <el-form-item label="图片信息：">
                      <image-list
                        v-if="item.proofImageList.length > 0"
                        :list="item.proofImageList" />
                    </el-form-item>
                    <el-form-item
                      v-if="item.details && item.details.length > 0"
                      label="订单明细:"
                      prop="details">
                      <el-table
                        v-loading="loading"
                        max-height="400px"
                        :data="item.details"
                        border>
                        <el-table-column
                          :resizable="false"
                          label="商品名称"
                          prop="productName"></el-table-column>
                        <el-table-column
                          :resizable="false"
                          label="商品编码"
                          width="80"
                          prop="productNumber"></el-table-column>
                        <el-table-column
                          label="退货数量"
                          width="70"
                          :resizable="false"
                          prop="goodsCount">
                          <template slot-scope="scope">{{ scope.row.goodsCount }} {{ scope.row.measureUnit | measureUnitName() }}</template>
                        </el-table-column>
                        <el-table-column
                          label="已退货数量"
                          :resizable="false"
                          prop="returnedGoodsCount">
                          <template slot-scope="scope">{{ scope.row.returnedGoodsCount }} {{ scope.row.measureUnit | measureUnitName() }}</template>
                        </el-table-column>
                      </el-table>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </layout-card-wrap>
        </template>
        <sh-empty v-else />

      </template>
    </el-form>
    <delivery-trace-modal ref="trace" />
    <order-remark-modal
      ref="remark"
      :callback="getoutstockorder" />
    <out-stock-tag-button ref="tag" />
  </layout-main-inner>
</template>
<script>
import NP from 'number-precision'
// import EntLogisticsSelect from '../../components/business/ent-logistics-select.vue'
import { mapState } from 'vuex'
// import VendorTagSelect from '../../components/business/vendor-tag-select.vue'
import ShEmpty from '../../components/public/empty.vue'
import ImageList from '../../components/image-list.vue'
import DeliveryTraceModal from '../outstock/busi/delivery-trace-modal.vue'
import OrderRemarkModal from './busi/order-remark-modal.vue'
import OutStockTagButton from '../../components/out-stock-tag-button.vue'
export default {
  name: 'OrdersDetail',
  components: { ShEmpty, ImageList, DeliveryTraceModal, OrderRemarkModal, OutStockTagButton },
  props: {},
  data() {
    return {
      activeName: '1',
      loading: false,
      outstock: {
        salesOrderDetailList: []
      },
      outList: [],
      returnList: [],
      saleList: [],
      sendlist: []
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log(to, from, next)
    if (to.fullPath !== from.fullPath) {
      next()
      this.activeName = this.$route.query.activeName || '1'
      // this.getsendlist()
      this.getoutstockorder()
      this.fetchOutList()
      this.fetchReturnList()
      this.getpostsaleorders()
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  created() {},
  mounted() {
    this.activeName = this.$route.query.activeName || '1'
    // this.getsendlist()
    this.getoutstockorder()
    this.fetchOutList()
    this.fetchReturnList()
    this.getpostsaleorders()
  },
  methods: {
    viewtags(row) {
      this.$refs.tag.fetch({
        dealOrderCode: this.outstock.code,
        productNumber: row.skuCode
      }, row)
    },
    editremark(row) {
      this.$refs.remark.fetch({
        salesOrderId: row.id,
        remark: row.remark,
        code: row.code
      })
    },
    getdeliverytrace(row) {
      this.$refs.trace.fetch({
        vendorId: row.parentOwnerCode,
        courierNumber: row.logisticsCode
      })
    },
    // getsendlist() {
    //   this.loading = true
    //   this.$store.dispatch('outstock/getsendlist', {
    //     payload: {
    //       pageNum: 1,
    //       pageSize: 100,
    //       salesOrderCode: this.$route.query.code
    //     },
    //     success: (res) => {
    //       this.loading = false
    //       this.sendlist = res.data.data.records.map(i => {
    //         return {
    //           ...i,
    //           expressCode: +i.expressCode
    //         }
    //       })
    //     },
    //     fail: () => {
    //       this.loading = false
    //     }
    //   })
    // },
    getpostsaleorders() {
      this.loading = true
      this.$store.dispatch('goodsreturn/getpostsaleorders', {
        payload: {
          pageNum: 1,
          pageSize: 100,
          dealOrderCode: this.$route.query.code
        },
        success: (res) => {
          this.loading = false
          this.saleList = res.data.records.map(i => {
            return {
              ...i,
              proofImageList: i.proofImage ? i.proofImage.split(',') : []
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchReturnList() {
      this.loading = true
      this.$store.dispatch('goodsreturn/getgoodsreturns', {
        payload: {
          pageNum: 1,
          pageSize: 100,
          dealOrderCode: this.$route.query.code
        },
        success: (res) => {
          this.loading = false
          this.returnList = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchOutList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('outstock/getoutlist', {
        payload: {
          pageNum: 1,
          pageSize: 100,
          bizOrderCode: this.$route.query.code,
          excludePrintTemplate: true
        },
        success: (res) => {
          this.loading = false
          this.outList = res.data.data.records.map(i => {
            return {
              ...i,
              sendOrderList: i.sendOrderList ? i.sendOrderList[0] : {}
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getoutstockorder() {
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: this.$route.query.salesOrderId
        },
        success: res => {
          const data = res.data.data
          const list = data.detailList.map(item => {
            return NP.times(Number(item.realOutNum), NP.divide(item.actualPrice, 100))
          })
          const outTotalAmount = list.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return NP.plus(prev, curr)
            } else {
              return prev
            }
          }, 0)
          this.outstock = {
            ...data,
            logisticsCode: +data.logisticsCode,
            orderFlag: +data.orderFlag,
            itemAmount: NP.divide(data.itemAmount, 100),
            totalAmount: NP.divide(data.totalAmount, 100),
            outTotalAmount: outTotalAmount,
            discountAmount: NP.divide(data.discountAmount, 100),
            detailList: data.detailList.map(s => {
              return {
                ...s,
                discountAmount: NP.divide(s.discountAmount, 100),
                actualPrice: NP.divide(s.actualPrice, 100),
                retailPrice: NP.divide(s.retailPrice, 100)
              }
            }),
            outDetailList: data.detailList.filter(i => i.realOutNum > 0).map(s => {
              return {
                ...s,
                discountAmount: NP.divide(s.discountAmount, 100),
                actualPrice: NP.divide(s.actualPrice, 100),
                retailPrice: NP.divide(s.retailPrice, 100)
              }
            })
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计：¥' + this.outstock.totalAmount + '；已发：¥' + this.outstock.outTotalAmount
          return
        }
        if (index === 2 || index === 3 || index === 1) {
          return
        }
        const values = data.map(item => {
          if (index >= 4) {
            return NP.times(Number(item[column.property]), Number(item.num))
          } else {
            return Number(item[column.property])
          }
        })
        // console.log(values)
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return NP.plus(prev, curr)
            } else {
              return prev
            }
          }, 0)
          if (index === 2 || index === 3) {
            sums[index] += '件'
          } else {
            sums[index] = '¥' + sums[index]
          }
        } else {
          sums[index] = 'N/A'
        }
      })
      return sums
    }
  }
}
</script>
<style lang="stylus">
.order-detail {
  // .zz-main-inner-header{
  //   margin-bottom: 0;
  // }
  .el-form--label-top .el-form-item__label {
    padding-bottom 0;
  }
  .el-tabs__header {
    margin-bottom: 8px

    .el-tabs__nav-wrap{
      background: #fff;
      padding 0 20px
    }
  }
.order-create-wrap {
  .el-table__footer-wrapper tbody {
    td:nth-child(1) {
      font-size: 14px !important;
      color: red !important;
    }
  }

  .el-form-item {
    margin-bottom: 0 !important;
  }
}
}
</style>
